/**Dependencies */
import React, { useState } from "react";

/**Components */
import { Button, Card } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

/**Styles */
import "../styles/components/interactiveCard.scss";

export const InteractiveCard = ({
  imageSrc,
  title,
  location,
  url,
  seccion,
  dates,
  id,
}) => {
  const [isActive, setIsActive] = useState(false);
  const navigate = useNavigate();
  const handleCardClick = () => {
    setIsActive(!isActive);
  };

  return (
    <>
      {seccion === "collections" ? (
        <Card
          onClick={handleCardClick}
          style={{ borderRadius: "2rem", border: "0" }}
        >
          <Card.Img
            src={`https://panel.marzahtravel.com/assets/uploads/colecciones/lista/${imageSrc}`}
            className="card-image"
            style={{
              width: "100%",
              height: "465px",
              objectFit: "fill",
              borderRadius: "1rem",
            }}
          />
          <div className="card-overlay">
            <div className="card-title d-grid mb-4">
              <h3
                style={{
                  top: "20%",
                  color: "#fff",
                  fontWeight: "800",
                  width: "55%",
                  textAlign: "center",
                  fontSize: "25px",
                  left: "50%",
                  position: "absolute",
                  transform: "translate(-50%, -50%)",
                }}
              >
                {title}
              </h3>
              <Link
                to={`/colecciones?category=${url}&idCategory=${id}`}
                onClick={() => {
                  window.scroll({ top: 0, left: 0, behavior: "smooth" });
                }}
              >
                <Button
                  className=" rounded-5 btn-blue"
                  style={{
                    left: "50%",
                    position: "absolute",
                    bottom: "5%",
                    transform: "translate(-50%, -50%)",
                    width: "150px",
                    fontSize: "16px",
                  }}
                >
                  Descubre más
                </Button>
              </Link>
            </div>
          </div>
        </Card>
      ) : (
        <>
          <Card
            onClick={handleCardClick}
            style={{ borderRadius: "2rem", border: "0" }}
          >
            <Card.Img
              src={
                "https://panel.marzahtravel.com/assets/uploads/carruseles/destinos/" +
                imageSrc
              }
              className="card-image shadow"
              style={{
                width: "100%",
                height: "420px",
                objectFit: "fill",
                borderRadius: "2rem",
              }}
            />
            <div
              className="card-overlay"
              style={{
                background:
                  "linear-gradient(rgb(65 100 149 / 30%) 0%, rgb(255 255 255 / 0%) 100%)",
                borderRadius: "2rem",
              }}
            >
              <div className="card-title d-grid mb-4">
                <h3
                  style={{
                    textShadow: "rgba(0, 0, 0, 1) 0px 1rem 3rem",
                    top: "20%",
                    color: "#fff",
                    fontWeight: "800",
                    width: "55%",
                    textAlign: "center",
                    fontSize: "25px",
                    left: "50%",
                    position: "absolute",
                    transform: "translate(-50%, -50%)",
                  }}
                >
                  {title}
                </h3>
                <Button
                  className=" rounded-5 btn-blue"
                  onClick={() => [
                    window.scroll({ top: 0, left: 0, behavior: "smooth" }),
                    navigate(
                      `${url}?t=destino&id=${location}&in=${dates?.[0]}&out=${
                        dates?.[1]
                      }&${seccion === "home" && "hab=1"}&pax1=2|0|0`
                    ),
                  ]}
                  style={{
                    left: "50%",
                    position: "absolute",
                    bottom: "5%",
                    transform: "translate(-50%, -50%)",
                    width: "150px",
                    fontSize: "16px",
                  }}
                >
                  Descubre más
                </Button>
              </div>
            </div>
          </Card>
        </>
      )}
    </>
  );
};
